module.exports = __webpack_public_path__ + "static/media/login-ad.67133fd3.jpg";